/** Resolver position patch → GeneratedLayout; untouched placements keep as-built geometry. */
import type { GeneratedLayout, GeneratedSegment, StudioItem } from "../domain/studioTypes";
import type { ResolverPosition } from "./cdtResolve";
import { placementId } from "./toResolverInputs";

export const resolvedLayout = (
  items: readonly StudioItem[],
  positions: Readonly<Record<string, ResolverPosition>>,
): GeneratedLayout => {
  const placements: Record<string, { skuId: string; segments: GeneratedSegment[] }> = {};
  for (const item of items) {
    const segments = item.placements.map((placement, index) => {
      const patch = positions[placementId(item.skuId, index)];
      return patch
        ? { run: patch.run, shelf: patch.shelf, xCm: patch.x, hFacings: patch.hf }
        : {
            run: placement.run,
            shelf: placement.shelf,
            xCm: placement.xCm,
            hFacings: placement.hFacings,
          };
    });
    placements[item.skuId] = { skuId: item.skuId, segments };
  }

  const walkOrder = [...items]
    .sort((a, b) => {
      const sa = placements[a.skuId].segments[0];
      const sb = placements[b.skuId].segments[0];
      return sa.run - sb.run || sa.shelf - sb.shelf || sa.xCm - sb.xCm;
    })
    .map((item) => item.skuId);

  return { placements, walkOrder };
};
